import React from 'react';
import { translate } from 'react-i18next';

import { Form } from 'common/components';

const ReportsDepreciationFilters = ({
  accounts = [],
  costCenters = [],
  employees = [],
  status = [],
  handleSubmit = () => {},
  handleValueChange = () => {},
  t,
  values = {},
}) => {
  const accountsOptions = accounts.map((a) => ({ label: `${a.key} - ${a.name}`, value: a.id }));
  const costCentersOptions = costCenters.map((c) => ({
    label: `${c.key} - ${c.name}`,
    value: c.id,
  }));
  const employeesOptions = employees.map((e) => ({ label: `${e.key} - ${e.name}`, value: e.id }));
  const statusNotDeleted = []; // Error al traer un dato como undefined.
  status.forEach((s) => (s ? statusNotDeleted.push(s) : null));
  const statusOptions = statusNotDeleted.map((s) => ({ label: t(s.value), value: s.id }));

  return (
    <form onSubmit={handleSubmit} noValidate autoComplete="false">
      <div className="row mt-3">
        <div className="col-sm-6 col-md-4">
          <Form.FieldInput
            autoFocus={true}
            label={t('actions.search')}
            name={'fulltext'}
            placeholder={t('actions.search')}
            handleChange={handleValueChange}
            value={values.fulltext}
          />
        </div>
        <div className="col-sm-6 col-md-4">
          <Form.FieldMultiSelect
            options={accountsOptions}
            autoFocus={true}
            label={t('reports.fields.accounts')}
            name={'accounts'}
            placeholder={t('reports.fields.accounts')}
            handleChange={handleValueChange}
            value={values.accounts}
          />
        </div>
        <div className="col-sm-6 col-md-4">
          <Form.FieldMultiSelect
            options={costCentersOptions}
            autoFocus={true}
            º
            label={t('reports.fields.costCenters')}
            name={'costCenters'}
            placeholder={t('reports.fields.costCenters')}
            handleChange={handleValueChange}
            value={values.costCenters}
          />
        </div>
        <div className="col-sm-6 col-md-4">
          <Form.FieldMultiSelect
            options={employeesOptions}
            autoFocus={true}
            º
            label={t('reports.fields.employees')}
            name={'employees'}
            placeholder={t('reports.fields.employees')}
            handleChange={handleValueChange}
            value={values.employees}
          />
        </div>
        <div className="col-sm-6 col-md-4">
          <Form.FieldMultiSelect
            options={statusOptions}
            autoFocus={true}
            º
            label={t('reports.fields.status')}
            name={'status'}
            placeholder={t('reports.fields.status')}
            handleChange={handleValueChange}
            value={values.status}
          />
        </div>
        <div className="col-sm-6 col-md-4">
          <Form.FieldSelect
            label={t('reports.fields.depreciationType')}
            name={'depreciationType'}
            noEmptyOption={true}
            handleChange={handleValueChange}
            value={values.depreciationType}
          >
            <option value="fiscal">{t('reports.values.depreciationType.fiscal')}</option>
            <option value="financial">{t('reports.values.depreciationType.financial')}</option>
          </Form.FieldSelect>
        </div>
        <div className="col-sm-6 col-md-4">
          <Form.FieldDate
            label={t('reports.fields.endDate')}
            name={'endDate'}
            placeholder={t('reports.fields.endDate')}
            handleChange={handleValueChange}
            value={values.endDate}
          />
        </div>
      </div>
    </form>
  );
};

export default translate()(ReportsDepreciationFilters);



// WEBPACK FOOTER //
// src/components/reports/depreciation/ReportsDepreciationFilters.js